import React, { Component } from 'react';
import './App.css';
import axios from 'axios';

// Original data used for testing ( now its fetched with axios)
// import data from './data/data.json'

// Components
import Flags from './components/Flags/Flags'
import Nav from './components/Nav/Nav'
import Table from './components/Table/Table'



class App extends Component {

	state = {
		data: [],
		sidemenu: {},
		selected: [],
		activeLang: 'france'
	}

	componentDidMount() {
		// Get data language
		axios.get(`data/data-france.json`)
			.then(res => {
				const data = res.data;
				this.setState({ data });
			})
			.catch(e => console.log('Error data JSON not found'))

		// Get side menu language
		axios.get(`data/sidemenu-france.json`)
			.then(res => {
				const sidemenu = res.data;
				this.setState({ sidemenu });
			})
			.catch(e => console.log('Error sidemenu JSON not found'))
	}

	addSelected = (id) => {
		const selected = this.state.data.find((item) => item.id === id)

		this.setState({
			selected: [...this.state.selected, selected]
		})
	}

	removeSelected = (id) => {
		const newState = this.state.selected.filter((item) => item.id !== id);
		this.setState({
			selected: newState
		})
	}


	selectLang = (clicked) => {

		this.setState({
			activeLang: clicked
		})

		// Get data language
		axios.get(`data/data-${clicked}.json`)
			.then(res => {
				const data = res.data;
				this.setState({ data });
			})
			.catch(e => console.log('Error JSON not found'))
		// Get side menu language
		axios.get(`data/sidemenu-${clicked}.json`)
			.then(res => {
				const sidemenu = res.data;
				this.setState({ sidemenu });
			})
			.catch(e => console.log('Error JSON not found'))
	}


	render() {
		return (
			<div className="App">

				<Flags selectLang={this.selectLang} />

				<h1>{this.state.sidemenu.mainTitle}</h1>

				<Nav data={this.state.data} add={this.addSelected} remove={this.removeSelected} />

				<Table sidemenu={this.state.sidemenu} selected={this.state.selected} />

			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js